module.exports = __webpack_public_path__ + "assets/img/suocang.b99fec16.png";